import service from '@/api/roleGroup';
import {loading, handleError} from '@/state/generators/helpers';
import {alert} from "../generators/helpers";

export const state = {
    loading: false,
    service: service('roleGroups')
}

export const getters = {

}

export const mutations = {
    'SET_LOADING': function (state, boolean = true) {
        state.loading = boolean
    },
}

export const actions = {
    roles: function ({commit, state}, payload) {
        loading(commit)

        const id = payload.id
        delete payload.id

        return state.service.syncRoles(id, payload).then(response => {
            loading(commit, false)
            alert(commit, this.$t('request.save_is_successful'))
            return response.data
        }).catch((e) => {
            handleError(e, commit)
        })
    },
}
